import { render, staticRenderFns } from "./EventReportDeactivationDialog.vue?vue&type=template&id=4027b614"
import script from "./EventReportDeactivationDialog.vue?vue&type=script&lang=ts"
export * from "./EventReportDeactivationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports